//decori images -- patters --combinations
import esagono from './images/DecoriPage/patterns/esagono.svg'
import herringBone from './images/DecoriPage/patterns/herringBone.svg'
import largeChalet from './images/DecoriPage/patterns/largeChalet.svg'
import smallChalet from './images/DecoriPage/patterns/smallChalet.svg'


// decori pattern images
import patternHerringBone from './images/DecoriPage/images/prestigio.png'
import patternEsagono from './images/DecoriPage/images/prestigio.png'
import patternChaletPiccolo from './images/DecoriPage/images/prestigio.png'
import patternChaletGrande from './images/DecoriPage/images/prestigio.png'



// ispirazione page images
import ispirazionePageFirstImage from './images/IspirazionePage/image.png'
import ispirazionePageSecondImage from './images/IspirazionePage/image2.png'
//Homepage bg
import homePagebg from './images/HomePage/bg.png'
import homePageImg from './images/HomePage/grandi-lastre.jpg'


import homePageVideoMobile from './images/HomePage/GL_atterraggio_375x500.mp4'
import homePageVideo from './images/HomePage/GL_atterraggio_1920x1080.mp4'


import collezionePageVideo from './images/Collezione/Foil_grandilastre_1920x1280.mp4'

import CtaPagePdf from './images/CtaPage/refin_large_slabs_09_2023.pdf'
// caratteristiche page images



import caratteristichePageSecondImage from './images/CaratteristichePage/1_Prestigio_Impero.jpg'
import caratteristichePageFirstImage from './images/CaratteristichePage/Prestigio-Calacatta-Oro-120x278.jpg'
import caratteristichePageThirdImage from './images/CaratteristichePage/GRANDI_LASTRE_VERTICALI_3.jpg'



import creosFirstImage from './images/DecoriPage/images/creos/CREOS_BRIDE_120X278_01_265.jpg'
import creosSecondImage from './images/DecoriPage/images/creos/CREOS_DORIAN_120X278_02_265.jpg'

import foilFirstImage from './images/DecoriPage/images/foil/FOIL_ALUMINIUM_120X278_001_265.jpg'
import foilSecondImage from './images/DecoriPage/images/foil/FOIL_BURNISH_120X278_002_265.jpg'

import plainFirstImage from './images/DecoriPage/images/plain/PLAIN_CINDER_120x278_01_265.jpg'
import plainSecondImage from './images/DecoriPage/images/plain/PLAIN_NICKEL_120x278_02_265.jpg'

import playFirstImage from './images/DecoriPage/images/PLAY/PLAY_WHITE_120X278_OC80_265.jpg'



import prestigio2023FirstImage from './images/DecoriPage/images/2023/prestigio/1_PRESTIGIO_STATUARIO-APUANO_120x278_265.jpg';
import prestigio2023SecondImage from './images/DecoriPage/images/2023/prestigio/2_PRESTIGIO_CALACATTA_ORO_120x278_265.jpg';
import prestigio2023ThirdImage from './images/DecoriPage/images/2023/prestigio/3_PRESTIGIO_NUVOLATO-120x278_265.jpg';
import prestigio2023FourthImage from './images/DecoriPage/images/2023/prestigio/4_PRESTIGIO_ARABESCATO_120x278_265.jpg';
import prestigio2023FifthImage from './images/DecoriPage/images/2023/prestigio/5_PRESTIGIO_OPERA_120x278_265.jpg'


import prestigioFirstImage from './images/DecoriPage/images/prestigio/PRESTIGIO_ARCADIA_120X278_001_265.jpg'
//import prestigioSecondImage from './images/DecoriPage/images/prestigio/PRESTIGIO_CALACATTA_120X278_02_265.jpg'
import prestigioThirdImage from './images/DecoriPage/images/prestigio/PRESTIGIO_IMPERO_LUCIDO_120X278_003_265.jpg'
//import prestigioFourthImage from './images/DecoriPage/images/prestigio/PRESTIGIO_MACAUBAS-LUCIDO_120X278_04_265.jpg'
import prestigioFifthImage from './images/DecoriPage/images/prestigio/PRESTIGIO_MARQUINIA-LUCIDO_120X278_05_265.jpg'
//import prestigioSixthImage from './images/DecoriPage/images/prestigio/PRESTIGIO_STATUARIO-LUCIDO_120X278_06_265.jpg'

import prestigioDecorsFirstImage from './images/DecoriPage/images/prestigio-decors/1---PRESTIGIO-CRAQUELE---120x278-Lucido.jpg'
import prestigioDecorsSecondImage from './images/DecoriPage/images/prestigio-decors/2---PRESTIGIO-MESH---120x278-Lucido.jpg'
//import prestigioDecorsThirdImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_CALACATTA-LUCIDO_CRAQUELE_120X278_02_265.jpg'
//import prestigioDecorsFourthImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_CALACATTA-LUCIDO_MESH_120X278_02_265.jpg'
import prestigioDecorsFifthImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_IMPERO-LUCIDO_CRAQUELE_120X278_03_265.jpg'
import prestigioDecorsSixthImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_IMPERO-LUCIDO_MESH_120X278_03_265.jpg'
import prestigioDecorsSeventhImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_MARQUINIA-LUCIDO_CRAQUELE_120X278_04_265.jpg'
import prestigioDecorsEightImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_MARQUINIA-LUCIDO_MESH_120X278_04_265.jpg'
//import prestigioDecorsNinethImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_STATUARIO-LUCIDO_CRAQUELE_120X278_05_265.jpg'
//import prestigioDecorsTenthImage from './images/DecoriPage/images/prestigio-decors/PRESTIGIO_STATUARIO-LUCIDO_MESH_120X278_05_265.jpg'



import prestigio2023MeshDecorsFirstImage from './images/DecoriPage/images/2023/prestigio-mesh/REFIN_PRESTIGIO_CALACATTA_ORO_MESH.jpg'
import prestigio2023MeshDecorsSecondImage from './images/DecoriPage/images/2023/prestigio-mesh/REFIN_PRESTIGIO_STATUARIO_APUANO_MESH.jpg'


import prestigioMeshDecorsFirstImage from './images/DecoriPage/images/prestigio-mesh/REFIN_IMMAGINI-PRESTIGIO-DECORI_STATUARIO_mesh_265.jpg'
//import prestigioMeshDecorsSecondImage from './images/DecoriPage/images/prestigio-mesh/REFIN_IMMAGINI-PRESTIGIO-DECORI_CALACATTA_mesh_265.jpg'
import prestigioMeshDecorsThirdImage from './images/DecoriPage/images/prestigio-mesh/REFIN_IMMAGINI-PRESTIGIO-DECORI_MARQUINIA_mesh_265.jpg'
import prestigioMeshDecorsFourthImage from './images/DecoriPage/images/prestigio-mesh/REFIN_IMMAGINI-PRESTIGIO-DECORI_IMPERO_mesh_265.jpg'
import prestigioMeshDecorsFifthImage from './images/DecoriPage/images/prestigio-mesh/REFIN_IMMAGINI-PRESTIGIO-DECORI_ARCADIA_mesh_265.jpg'

import prestigioCraqueleDecorsFirstImage2023 from './images/DecoriPage/images/2023/prestigio-craquele/REFIN_PRESTIGIO_STATUARIO_APUANO_CRAQUELE.jpg'
import prestigioCraqueleDecorsSecondImage2023 from './images/DecoriPage/images/2023/prestigio-craquele/calacatta.jpg'
//import prestigioCraqueleDecorsFirstImage from './images/DecoriPage/images/prestigio-craquele/REFIN_IMMAGINI-PRESTIGIO-DECORI_STATUARIO_craquele_265.jpg'
//import prestigioCraqueleDecorsSecondImage from './images/DecoriPage/images/prestigio-craquele/REFIN_IMMAGINI-PRESTIGIO-DECORI_CALACATTA_craquele_265.jpg'
import prestigioCraqueleDecorsThirdImage from './images/DecoriPage/images/prestigio-craquele/REFIN_IMMAGINI-PRESTIGIO-DECORI_MARQUINIA_craquele_265.jpg'
import prestigioCraqueleDecorsFourthImage from './images/DecoriPage/images/prestigio-craquele/REFIN_IMMAGINI-PRESTIGIO-DECORI_IMPERO_craquele_265.jpg'
import prestigioCraqueleDecorsFifthImage from './images/DecoriPage/images/prestigio-craquele/REFIN_IMMAGINI-PRESTIGIO-DECORI_ARCADIA_craquele_265.jpg'

import prestigioOnyxFirstImage from './images/DecoriPage/images/prestigio-onyx/PRESTIGIO-ONYX_WHITE-LUCIDO_120X278_02_265.jpg'


import tuneZeroImage from './images/DecoriPage/images/2023/tune/1_Tune_Ivory_120x278_265.jpg'
import tuneFirstImage from './images/DecoriPage/images/tune/TUNE_DESERT_120X278_01_265.jpg'
import tuneSecondImage from './images/DecoriPage/images/tune/TUNE_ROCK_120X278_02_265.jpg'
import tuneThirdImage from './images/DecoriPage/images/tune/TUNE_SNOW_120X278_03_265.jpg'



import riverFirstImage from './images/DecoriPage/images/2023/river/1_RIVER_BEIGE_120X278_265.jpg'
import riverSecondImage from './images/DecoriPage/images/2023/river/2_RIVER_WHITE_120X278_265.jpg'
import riverThirdImage from './images/DecoriPage/images/2023/river/3_RIVER_GREY_120X278_265.jpg'


export const HomePageConfig = {
	MenuSideBarElements: [
		'start',
		'characteristics',
		'maxi size',
		'range',
		'download',
		'contacts'
	],
	id: 'start',
	website: 'https://www.refin-ceramic-tiles.com/',
	title: 'Large Slabs',
	secondary: 'Great solutions for surfaces',
	videoUrl: homePageVideo,
	videoUrlMobile: homePageVideoMobile,
	navbar: {
		btnColor: '#FFF',
		btnBackground: '#000'
	},
	bg: homePagebg,
	firstContainer: homePageImg,
	contactbtn: 'Contact Us',
	contactbtnslug: '#contacts'
}
export const CaratteristichePageConfig = {
	id:'characteristics',

	firstContainer: {
	
		image:caratteristichePageSecondImage,

		alt :'Prestigio Marquinia Craquelé 120x278',
		alt2 :'/48"×110" R Lucido',
		content: {
			primary: 'Aesthetic beauty and technical performance',
			secondary: ['The maxi-size ', '120x278/48\'\'x110\'\'',' with a thin', ' thickness of 6 mm',' combines the strength of porcelain stoneware with a continuous surface where joints are reduced to a minimum.'],
			tertiary: ['']
		},
		imageOffset: '-50px',
		imageOffsetMobile: '-150px',
		primaryTextOffset: '350px',
		primaryTextOffsetMobile: '300px',
		subTextOffset: '400px',
		subTextOffsetMobile: '350px'
	},
	secondContainer: {
		image:  caratteristichePageFirstImage,
		alt :'Prestigio Calacatta Oro 120x278',
		alt2 :'/48"x110 R Lucido',
		content: {
			primary: 'Ultimate design freedom',
			secondary: ['The creative and design opportunities are endless, thanks to striking continuity effects and great versatility of application.'],
			tertiary: ['']
		},
		imageOffset: '300px',
		imageOffsetMobile: '500px',
		primaryTextOffset: '300px',
		primaryTextOffsetMobile: '250px',
		subTextOffset: '350px',
		subTextOffsetMobile: '300px'
	}
}
export const CollezioniPageConfig = {
	id:'maxi_size',
	title: ['One size.','Endless possibilities.'],
	secondary: 'An even bigger technological and aesthetic power. The maxi size 120x278/48\'\'x110\'\' envelops and enhances every element.',
	videoUrl: collezionePageVideo,
}


export const DecoriPageConfig = {
	id: 'range',
	content: {
		primary: 'A comprehensive and complete range.',
		secondary: ['Discover all our surfaces and interpret each project in a unique way.']
	},
	mobileContent: {
		primary: 'A comprehensive and complete range.',
		secondary: ['Discover all our surfaces and interpret each project in a unique way.']
	},
	patterns: [
		{
			name: 'Prestigio',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Marble look'
		},
		{
			name: 'Prestigio Craquelé',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Marble look'
		},
		{
			name: 'Prestigio Mesh',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Marble look'
		},
		{
			name: 'Prestigio Onyx',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Marble look'
		},
		{
			name: 'Creos',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Resin Look',
			images: {
				first: creosFirstImage,
				second: creosSecondImage
			},
		},
		{
			name: 'Foil',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Metal look'
		},
		{
			name: 'Plain',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Concrete look'
		},
		{
			name: 'Play',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Solid Color'
		},
		{
			name: 'Tune',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'Stone look'
		},
		{
			name: 'River',
			firstDimension: '',
			secondDimension: '',
			src: '',
			content: 'The force of nature'
		}
	],
	patternImages: [
		{
			images:
			[
				{
					name: 'Prestigio Statuario Apuano',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023FirstImage,
					content: '48"x110" R'
				},
				{
					name: 'Prestigio Calacatta Oro',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023SecondImage,
					content: '48"x110" R'
				},
				{
					name: 'Prestigio Nuvolato',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023ThirdImage,
					content: '48"x110" R'
				},
				{
					name: 'Prestigio Arabescato',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023FourthImage,
					content: '48"x110" R'
				},
				{
					name: 'Prestigio Opera',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023FifthImage,
					content: '48"x110" R'
				},


// 				{
// 					name: 'Prestigio Statuario',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioSixthImage,
// 					content: '48"x110" R'
// 				},
// 				{
// 					name: 'Prestigio Calacatta',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioSecondImage,
// 					content: '48"x110" R'
// 				},
// 				{
// 					name: 'Prestigio Macaubas',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioFourthImage,
// 					content: ''
// 				},
				{
					name: 'Prestigio Impero',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioThirdImage,
					content: ''
				},
				{
					name: 'Prestigio Marquinia',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioFifthImage,
					content: ''
				},
				{
					name: 'Prestigio Arcadia',
					firstDimension:'120x278',
					secondDimension: '48"x110 R Lucido',
					src: prestigioFirstImage,
					content: ''
				},
			],
		},
		{
			images:
			[
				{
					name: 'Prestigio Statuario Apuano Craquelé',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioCraqueleDecorsFirstImage2023,
					content: ''
				},
				{
					name: 'Prestigio Calacatta Oro Craquelé',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioCraqueleDecorsSecondImage2023,
					content: ''
				},
// 				{
// 					name: 'Prestigio Statuario Craquelé',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioCraqueleDecorsFirstImage,
// 					content: ''
// 				},
// 				{
// 					name: 'Prestigio Calacatta Craquelé',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioCraqueleDecorsSecondImage,
// 					content: ''
// 				},
				{
					name: 'Prestigio Marquinia Craquelé',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioCraqueleDecorsThirdImage,
					content: ''
				},
				{
					name: 'Prestigio Impero Craquelé',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioCraqueleDecorsFourthImage,
					content: ''
				},
				{
					name: 'Prestigio Arcadia Craquelé',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioCraqueleDecorsFifthImage,
					content: ''
				},
			],
		},
		{
			images:
			[
				{
					name: 'Prestigio Statuario Apuano Mesh',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023MeshDecorsSecondImage,
					content: ''
				},
				{
					name: 'Prestigio Calacatta Oro Mesh',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigio2023MeshDecorsFirstImage,
					content: ''
				},

// 				{
// 					name: 'Prestigio Statuario Mesh',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioMeshDecorsFirstImage,
// 					content: ''
// 				},
// 				{
// 					name: 'Prestigio Calacatta  Mesh',
// 					firstDimension:'120x278',
// 					secondDimension:'48"x110" R Lucido',
// 					src: prestigioMeshDecorsSecondImage,
// 					content: ''
// 				},
				{
					name: 'Prestigio Marquinia Mesh',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioMeshDecorsThirdImage,
					content: ''
				},
				{
					name: 'Prestigio Impero  Mesh',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioMeshDecorsFourthImage,
					content: ''
				},
				{
					name: 'Prestigio Arcadia  Mesh',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioMeshDecorsFifthImage,
					content: ''
				},
			],
		},
		{
			images:
			[
				{
					name: 'Prestigio Onyx White',
					firstDimension:'120x278',
					secondDimension:'48"x110" R Lucido',
					src: prestigioOnyxFirstImage,
					content: ''
				}
			],
		},
		{
			images:
			[
				{
					name: 'Creos Bride',
					firstDimension:'120x278',
					secondDimension: '48"x110" R',
					src: creosFirstImage,
					content: ''
				},
				{
					name: 'Creos Dorian',
					firstDimension:'120x278',
					secondDimension: '48"x110" R',
					src: creosSecondImage,
					content: ''
				},
			],
		},	
		{
			images:
			[
				{
					name: 'Foil Aluminium',
					firstDimension:'120x278',
					secondDimension: '48"x110" R',
					src: foilFirstImage,
					content: ''
				},
				{
					name: 'Foil Burnish',
					firstDimension:'120x278',
					secondDimension: '48"x110" R',
					src: foilSecondImage,
					content: ''
				},
			],
		},
		{
			images:
			[
				{
					name: 'Plain Cinder',
					firstDimension:'120x278',
					secondDimension: '48"x110" R',
					src: plainFirstImage,
					content: ''
				},
				{
					name: 'Plain Nickel',
					firstDimension:'120x278',
					secondDimension: '48"x110" R',
					src: plainSecondImage,
					content: ''
				},
			],
		},
		{
			images:
			[
				{
					name: 'Play White',
					firstDimension:'120x278',
					secondDimension: '48"x110 R',
					src: playFirstImage,
					content: ''
				}
			],
		},
		{
		images:
			[
				{
					name: 'Tune Ivory',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: tuneZeroImage,
					content: ''
				},
				{
					name: 'Tune Snow',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: tuneThirdImage,
					content: ''
				},
				{
					name: 'Tune Rock',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: tuneSecondImage,
					content: ''
				},
				{
					name: 'Tune Desert',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: tuneFirstImage,
					content: ''
				},
			],
		},
		{
		images:
			[	
				{
					name: 'River Beige',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: riverFirstImage,
					content: ''
				},
				{
					name: 'River White',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: riverSecondImage,
					content: ''
				},
				{
					name: 'River Grey',
					firstDimension:'120x278',
					secondDimension:'48"x110" R',
					src: riverThirdImage,
					content: ''
				},
			],
		},
	],
	primaryTextOffset: '450px',
	primaryTextOffsetMobile: '100px',
	subTextOffset: '500px',
	subTextOffsetMobile: '100px'
}
export const IspirazionePageConfig = {
    images: {
        first: ispirazionePageFirstImage,
        second: ispirazionePageSecondImage
    },
    content: {
        first: "Il gusto pregiato della tradizione",
        second: ['Cortina è  come un viaggio, ispirato al legno di recupero da', ' antiche baite alpine', ' sapientemente rilavorato nel rispetto naturale delle sue ', 'diverse essenze.'],
        third: ['Un percorso inedito, dove l’', 'esperienza catartica', ' della natura incontra la', ' forte personalità', ' estetica contemporanea.']
    },
    pageOffsetFromTopDesktop: '-150px', // to keep all the content in the top, not interfering with the navbar
    pageOffsetFromTopMobile: '-50px', // the mobile version, the lower the value the lower it will animate
    firstPhotoOffsetAnim: '250px', // this controls when should the photo animate when it is in viewport
    firstPhotoOffsetMobile: '400px', // same as above but for mobile
    primaryTextOffset: '200px', // the lower the value, the higher it will animate depending on the viewport
    primaryTextOffsetMobile: '200px',
    subTextOffset: '400px',
    subTextOffsetMobile: '150px',
    secondPhotoOffset: '200px',
    secondPhotoOffsetMobile: '300px'
}

export const ProcessoPageConfig = {
    content: {
        primary: ['La ricerca di un', 'equilibrio autentico'],
        secondary: ['', 'Un mix energico e bilanciato', ', nato dalla collaborazione con una prestigiosa falegnameria del bellunese, specializzata nel recupero di legnami antichi per esclusivi ambienti di lusso. Della ', 'sapienza artigiana alpina', ',  Cortina reinterpreta la ricerca e selezione delle doghe migliori di legni diversi, dando vita a un raffinato equilibrio di essenze. ', 'Per una superficie difficilmente replicabile.'],
    },
	video: {
        id: '581728609'
    },
    primaryTextOffset: '300px',
    primaryTextOffsetMobile: '200px',
    subTextOffset: '300px',
    subTextOffsetMobile: '300px'
}

export const ColoriFormatiPageConfig = {
    content: {
        primary: 'Più colori per ogni formato',
        secondary: ['Almond, Honey, Natural e Tobacco esaltano la varietà e la ricchezza naturale del legno con', ' tonalità inedite', ', più moderne e versatili. Ogni colore è reso unico dall’esclusiva', ' stonalizzazione cromatica e grafica', ', creando avvolgenti giochi di contrasto e pregiati intrecci lignei.']
    },
    primaryTextOffset: '150px',
    primaryTextOffsetMobile: '300px',
    subTextOffset: '300px',
    subTextOffsetMobile: '300px'
}

export const FormConfiguration = {
    paesi: [
        'Italia',
        'Albania',
        'Germany',
        'France',
        'Inghilterra'
    ],
    citta: [
        'Milano',
        'Torino',
        'Roma',
        'Napoli'
    ],
    cap: [
        '20100',
        '12838',
        '123123',
        '1231212'
    ],
    infoSulPrivacy: 'http://wikipedia.it'
}

export const FooterLinks = {
    sedeLegale: '/location',
    showroom: '/location'
}

export const SocialLinks = {
    facebook: 'https://facebook.com',
    linkedin: 'linkedin.com',
    twitter: 'twitter.com',
    instagram: 'instagram.com',
    pinterest: 'pinterest.com',
    youtube: 'youtube.com'
}



export const CtaPageConfig = {
	title: 'Discover the details ',
	cta: 'Download the catalogue',
	url: CtaPagePdf,
}
